module.exports = __webpack_public_path__ + "static/under_construction-8329224e92720f1b40cd3ab16d3407fb.svg";